import { SettingsView } from "@/features/settings/components/SettingsView"

export default function SettingsPage() {
  return <SettingsView />
}